import { useMemo } from 'react';

import { sanitizeHtml } from '@/lib/sanitizeHtml';
import { cn } from '@/lib/utils';

interface SafeHtmlProps extends React.HTMLAttributes<HTMLDivElement> {
  html: string;
}

/**
 * Renders sanitized rich text with readable defaults for titles and
 * paragraphs (works with <h1-6> and the `tom-de-voz-titulo` / `-texto`
 * paragraph classes).
 */
export function SafeHtml({ html, className, ...props }: SafeHtmlProps) {
  const safeHtml = useMemo(() => sanitizeHtml(html), [html]);

  return (
    <div
      className={cn(
        'space-y-2 text-sm leading-relaxed',
        '[&_.tom-de-voz-titulo:first-child]:mt-0 [&_.tom-de-voz-titulo]:mt-3 [&_.tom-de-voz-titulo]:font-semibold',
        '[&_h1]:font-semibold [&_h2]:font-semibold [&_h3]:font-semibold [&_h4]:font-semibold [&_h5]:font-semibold [&_h6]:font-semibold',
        '[&_ol]:list-decimal [&_ol]:pl-5 [&_ul]:list-disc [&_ul]:pl-5',
        className,
      )}
      {...props}
      dangerouslySetInnerHTML={{ __html: safeHtml }}
    />
  );
}
